import { LongPressContext } from 'global/cnr/contexts/LongPressContext'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import { gEnums } from 'global/enums/globalEnums'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import SportsEditMatchProvider from 'projectSpecific/sports/cnr/contexts/SportsEditMatchContext'
import SportsMatchProvider, { SportsMatchContext } from 'projectSpecific/sports/cnr/contexts/SportsMatchContext'
import { SportsRtMatchContext } from 'projectSpecific/sports/cnr/contexts/SportsRtMatchContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { matchExternalTypes, matchModifyTypes, matchUpdateTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import { CreateMatchResult_withProvider } from 'projectSpecific/sports/create/CreateMatchResult'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import MatchDetailsUpdate from './MatchDetailsUpdate'
import { MatchPendings } from './MatchPendings'
import { PlayoffLocations } from './PlayoffLocations'

const _baseTypes_match = {
  options: 'options',
  matchResultTypes: 'matchResultTypes',
  matchResult: 'matchResult',
  matchExternal: 'matchExternal',
  matchEdit: 'matchEdit',
  matchModifications: 'matchModifications',
  matchPendings: 'matchPendings',
  matchOption: 'matchOption',
  playoffLocations: 'playoffLocations',
  realtimeScoring: 'realtimeScoring',
}

const _optionTypes_admin = {
  matchExternal: 'matchExternal',
  matchModifications: 'matchModifications',
  matchEdit: 'matchEdit',
  matchPendings: 'matchPendings',
  matchResults: 'matchResults',
  playoffLocations: 'playoffLocations',
  realtimeScoring: 'realtimeScoring',
}

const _optionTypes_public = {
  matchResults: 'matchResults',
}

const _matchResultTypes = {
  matchScores: 'matchScores',
  setScores: 'setScores',
}

const MatchOptionsSquares = ({ match_true }) => {

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper: isSda, displayName } = appUserAccess ?? {}

  const longPressContext = useContext(LongPressContext);
  const { longPress_handlers } = longPressContext ?? {}

  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state, sportsMatch_handlers } = sportsMatchContext ?? {}
  const { match_true: mt, matchAllows } = sportsMatch_state ?? {}

  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_handlers } = sportsRtMatchContext ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext
  const { details_info } = sportsSeason_state ?? {}
  const { details } = details_info ?? {}
  const { sportsScoringAuthType } = details ?? {}

  const [allGroups, setAllGroups] = useState([])

  const currentGroup = allGroups?.[allGroups.length - 1]

  const { _results } = match_true ?? {}
  const { complete: complete_true } = _results ?? {}

  const iconProps = useMemo(() => {
    let icon = 'user'
    let color = 'green'
    let caption = 'Public'

    switch (sportsScoringAuthType) {
      case gEnums.sportsScoringAuthTypes.authUser:
        icon = 'user secret'
        color = 'red'
        caption = displayName ? displayName : 'Authorized Only'
        break;
      case gEnums.sportsScoringAuthTypes.appUser:
        icon = 'user'
        color = 'blue'
        caption = displayName ? displayName : 'App Users Only'
        break;
      case gEnums.sportsScoringAuthTypes.public:
        icon = 'users'
        color = 'green'
        caption = 'Public'
        break;
    }

    return { icon, color, caption }
  }, [sportsScoringAuthType])

  useEffect(() => {
    const _allGroups = []
    _allGroups.push({
      key: _baseTypes_match.options,
      value: '',
      caption: _.startCase(_baseTypes_match.options),
      menuItems: isSda ? _optionTypes_admin : _optionTypes_public
    })
    setAllGroups(_allGroups)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const addToGroup = (group) => {
    const _allGroups = _.clone(allGroups)
    _allGroups.push(group)
    setAllGroups(_allGroups)
  }

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group) => (
        {
          key: group.key || 0,
          caption: group.caption
        }
      )
    );
    return bl
  }, [allGroups])

  const goBack = () => {
    const _allGroups = _.clone(allGroups)
    if (_allGroups.length <= 1) { return; }
    const all_groups = _allGroups.slice(0, -1)
    setAllGroups(all_groups)
  }

  const goBackTo = (index) => {
    const _allGroups = _.clone(allGroups)
    if (index < 0 || index >= _allGroups.length) return;
    if (_allGroups.length <= 1) return; // ⛔ root protected 
    const all_groupz = _allGroups.slice(0, index + 1)
    setAllGroups(all_groupz)
  }

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: goBackTo })

  const onClick_optionType = (value) => {
    switch (value) {
      case _optionTypes_admin.matchResults:
        return addToGroup({ key: _baseTypes_match.matchResultTypes, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })

      case _optionTypes_admin.realtimeScoring:
        sportsRtMatch_handlers.handleShow_rtMatch()
        longPress_handlers && longPress_handlers.handleCancel()
        // if (complete_true) { return; }
        return;
      // return addToGroup({ key: _baseTypes_match.realtimeScoring, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchExternal:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchExternal, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchModifications:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchModifications, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchPendings:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchPendings, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.playoffLocations:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.playoffLocations, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchEdit:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchEdit, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })
    }
  }

  const onClick_matchResultType = (value) => {
    addToGroup({ key: _baseTypes_match.matchResult, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const onClick_matchOptions = (value) => {
    addToGroup({ key: _baseTypes_match.matchOption, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const fnAltContent_options = (item) => {
    let icns = []
    switch (item) {
      case _optionTypes_admin.matchResults:
        icns.push(<Icon name={iconProps.icon} color={iconProps.color} title={iconProps.caption} />)
        icns.push(<Icon name={'check circle outline'} color={complete_true ? 'green' : 'blue'} />)
        break;
      case _optionTypes_admin.realtimeScoring:
        icns.push(<Icon name={iconProps.icon} color={iconProps.color} title={iconProps.caption} />)
        icns.push(<Icon name={complete_true ? 'ban' : 'check circle outline'} color={complete_true ? 'red' : 'blue'} />)
        break;
      case _optionTypes_admin.matchExternal:
        icns.push(<Icon name={!isSda ? 'ban' : 'check circle outline'} color={!isSda ? 'red' : 'blue'} />)
        break;
      case _optionTypes_admin.matchModifications:
        icns.push(<Icon name={!isSda ? 'ban' : 'check circle outline'} color={!isSda ? 'red' : 'blue'} />)
        break;
      case _optionTypes_admin.matchPendings:
        icns.push(<Icon name={!isSda ? 'ban' : 'check circle outline'} color={!isSda ? 'red' : 'blue'} />)
        break;
      case _optionTypes_admin.playoffLocations:
        icns.push(<Icon name={!isSda ? 'ban' : 'check circle outline'} color={!isSda ? 'red' : 'blue'} />)
        break;
      case _optionTypes_admin.matchEdit:
        icns.push(<Icon name={!isSda ? 'ban' : 'check circle outline'} color={!isSda ? 'red' : 'blue'} />)
        break;
      default:
      // nothing
    }
    return icns
  }

  const fnSubContent = (item) => {
    switch (item) {
      case _matchResultTypes.matchScores:
        return <div>{`ex. 3-1`}</div>
      case _matchResultTypes.setScores:
        return <div>{`ex. 25-21, 20-25, 25-18, 25-23`}</div>
    }

  }

  // squares based on currentGroup
  const squares_options = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_optionType} fn_altContent={fnAltContent_options} />
  const squares_matchResultType = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchResultType} fn_subContent={fnSubContent} />
  const squares_matchModifications = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchOptions} />
  const squares_matchOptions = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchOptions} />

  const content_currentGroup = () => {
    if (allGroups) {
      const { key, menuItems, value } = currentGroup ?? {}
      switch (key) {
        case _baseTypes_match.options:
          return squares_options(menuItems)
        case _baseTypes_match.matchResultTypes:
          return squares_matchResultType(menuItems)
        case _baseTypes_match.matchExternal:
          return squares_matchModifications(matchExternalTypes)
        case _baseTypes_match.matchModifications:
          return squares_matchModifications(matchModifyTypes)
        case _baseTypes_match.matchEdit:
          return squares_matchOptions(matchUpdateTypes)
        case _baseTypes_match.matchResult:
          return <CreateMatchResult_withProvider
            match={match_true}
            matchKey={match_true?._itemKey}
            matchResultType={value}
          />
        case _baseTypes_match.matchPendings:
          return <MatchPendings />
        case _baseTypes_match.playoffLocations:
          return <PlayoffLocations />
        case _baseTypes_match.realtimeScoring:
          // turn on realtime scoring
          console.log('sportsMatch_handlers',)
          return <div>Realtime Scoring</div>

        case _baseTypes_match.matchOption:
          return <SportsMatchProvider match={match_true} matchKey={match_true._itemKey} matchUpdateType={value}>
            <SportsEditMatchProvider match={match_true} matchUpdateType={value}>
              <MatchDetailsUpdate match={match_true} matchUpdateType={value} />
            </SportsEditMatchProvider>
          </SportsMatchProvider>
      }
    }
  }

  const header_top = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { caption, key } = currentGroup ?? {}
    const _caption = caption || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'>
        {allGroups.length > 1 && <Icon color={'blue'} name='arrow left' onClick={() => goBack()}></Icon>}
        {_caption}</div>
    </div>
  }

  const wrapper = () => <Wrapper
    topper={<div style={{ textAlign: 'center' }}>{`${match_true?._status?.matchName} - ${displayName || 'Public'}`}</div>}
    header={header_top()}
    content={content_currentGroup()}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  return wrapper()
}

export default MatchOptionsSquares